import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

const icons = [{ home: HomeOutlinedIcon }];

const FilterTags = ({
  categories,
  selectedTags,
  handleSelectedTags,
  allTags,
  selectedIcon,
  setSelectedIcon,
  navigate,
}: {
  categories: Categories;
  selectedTags: string[];
  handleSelectedTags: (tagName: string) => void;
  allTags: string;
  selectedIcon: number;
  setSelectedIcon: (index: number) => void;
  navigate: Navigate;
}) => {
  const formatSelectedTags =
    selectedTags?.length > 0
      ? selectedTags.map((tag) => tag.toLocaleLowerCase())
      : [allTags.toLocaleLowerCase()];

  const sortedCategories = categories
    .filter((category) => category.name.toLocaleLowerCase() !== 'alltags')
    .toSorted((a, b) => a.name.localeCompare(b.name));

  const createButton = (tagName: string) => {
    return (
      <ListItemButton
        classes={{
          root: `filter-tags-list-item ${formatSelectedTags.includes(tagName.toLocaleLowerCase()) ? 'selected' : ''}`,
        }}
        onClick={() => handleSelectedTags(tagName)}
        key={tagName}
      >
        <ListItemText
          classes={{ primary: 'filter-tags-list-text' }}
          primary={tagName}
        />
      </ListItemButton>
    );
  };

  const list = sortedCategories.map((category) => {
    return (
      <div key={category.name}>
        <div className="filter-tags-list-category">{category.name}</div>
        {category.tags.map((tag) => (
          <ListItem key={tag.name} disablePadding>
            {createButton(tag.name)}
          </ListItem>
        ))}
      </div>
    );
  });
  list.unshift(createButton(allTags));

  return (
    <Box className="filter-tags" sx={{ display: 'flex', flexDirection: 'row' }}>
      <List classes={{ root: 'filter-tags-icons' }}>
        {icons.map((icon, index) => {
          const name = Object.keys(icon)[0];
          const Icon = Object.values(icon)[0];
          return (
            <ListItem
              classes={{
                root: `tag-icon ${selectedIcon === index ? 'selected' : ''}`,
              }}
              key={name}
              disablePadding
              onClick={() => navigate('/dashboard')}
            >
              <Icon />
            </ListItem>
          );
        })}
      </List>
      <List classes={{ root: 'filter-tags-list' }}>{list}</List>
    </Box>
  );
};

export default FilterTags;
